
export const VIEW_TYPE = {
    LIST: {
        viewType: 1,
        name: 'list'
    },
    GRID: {
        viewType: 2, // List with image
        name:'grid'
    }
}

export function getViewTypeByName(name) {
    const item = Object.values(VIEW_TYPE).find(v => v.name === name);
    return item ? item.viewType : VIEW_TYPE.LIST.viewType;
}



export const VIEW_TYPE_LOGISTICS = {
    ASSIGNED :  0,
    REQUESTED :  1,
    HISTORY : 2

}
